import "./ProductDesigner.scss"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { Button, ImageUploader, ColorPicker, Thumbnail } from "../../lib"
import { authStore, addProductStore } from "../../stores"
import DesignerCanvas from "./DesignerCanvas"

class ProductDesigner extends Component {
  state = {
    validDPI: true,
    activeColor: null,
    activeFileId: addProductStore.productFiles[0].id,
  }

  get activeColor() {
    return this.state.activeColor || addProductStore.selectedColor
  }

  get activeDesign() {
    return addProductStore.productDesigns[this.state.activeFileId] || {}
  }

  get valid() {
    return (
      Object.keys(addProductStore.productDesigns).length > 0 &&
      this.state.validDPI
    )
  }

  get errorMessage() {
    if (!this.valid) {
      if (!this.state.validDPI) {
        return "Image DPI (pixels per inch) is too low. Try resizing the image in the designer preview or upload a higher-res image."
      }
      return "Please upload a design"
    }
  }

  render() {
    const {
      productFiles,
      productMockups,
      productDesigns,
      selectedColor,
      variantColors,
      submitDesign,
      selectColor,
      selectImageForDesign,
      changePlacementForDesign,
    } = addProductStore
    const { activeFileId } = this.state
    return (
      <div className="ProductDesigner">
        <div className="ProductDesigner_config">
          <div className="ProductDesigner_color">
            <h5>Choose a color</h5>
            <ColorPicker
              colors={variantColors}
              value={selectedColor}
              onMouseOver={color => this.setState({ activeColor: color })}
              onMouseOut={e => this.setState({ activeColor: null })}
              onChange={selectColor}
            />
          </div>
          <ul className="ProductDesigner_files">
            {productFiles.map(file => (
              <li key={file.id}>
                <h5>
                  {file.title}{" "}
                  {file.additional_price && `($${file.additional_price})`}
                </h5>
                <ImageUploader
                  value={productDesigns[file.id] && productDesigns[file.id].url}
                  onChange={url => selectImageForDesign(url, file.id)}
                />
              </li>
            ))}
          </ul>
          <Button
            disabled={!this.valid}
            styleName="submit"
            onClick={submitDesign}>
            Configure
          </Button>
          <p className="ProductDesigner_error">{this.errorMessage}</p>
        </div>
        <div className="ProductDesigner_preview">
          <DesignerCanvas
            width={400}
            key={activeFileId}
            image={this.activeDesign.url}
            design={this.activeDesign}
            mockup={productMockups[activeFileId]}
            mockupColor={this.activeColor}
            onValid={() => this.setState({ validDPI: true })}
            onInvalid={() => this.setState({ validDPI: false })}
            onChange={placement =>
              changePlacementForDesign(placement, activeFileId)}
          />
          <ul className="ProductDesigner_thumbnails">
            {productFiles.map(file => (
              <li
                key={file.id}
                style={{ margin: 5 }}
                onClick={e => this.setState({ activeFileId: file.id })}>
                <h6 style={{ margin: 0 }}>{file.title}</h6>
                <Thumbnail
                  size={50}
                  color={this.activeColor}
                  design={productDesigns[file.id]}
                  mockup={productMockups[file.id]}
                  mockupColor={this.activeColor}
                  style={{
                    borderColor:
                      file.id === activeFileId ? "black" : "rgba(0,0,0,0.2)",
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default observer(ProductDesigner)



// WEBPACK FOOTER //
// ./src/products/add/ProductDesigner.js